import { IItem } from "../interfaces/items/item.interface";
import { IProjectComponent } from "../interfaces/project/project-component.interface";
import { IProjectSparePart } from "../interfaces/project/project-spare-part.interface";

export class ProjectSparePart implements IProjectSparePart {

    public appliedPrice?: number | null;
    public totalPrice?: number | null;

    get idProjectSparePart(): number {
        return this._idProjectSparePart;
    }

    get quantity(): number {
        return this._quantity;
    }

    constructor(
        private _idProjectSparePart: number,
        public idProject: number,
        public idItem: number,
        public itemMethodCode: string,
        public itemDescription: string,
        private _quantity: number
    ) {}

    public setQuantity(quantity: number): void {
        this._quantity = quantity;
    }

    public getComponentTitle(): string {
        return `${this.itemMethodCode}`;
    }

    public formatToSectionItem(): IProjectComponent {
        return {
            id: this._idProjectSparePart,
            name: this.getComponentTitle(),
            completed: false,
            quantity: this.quantity
        };
    }

    public formatToItem(): IItem {
        return {
            idItem: this.idItem,
            navCode: '',
            methodCode: this.itemMethodCode,
            description: this.itemDescription,
            quantity: this.quantity,
            unitPrice: this.appliedPrice ?? null,
            totalPrice: this.totalPrice ?? null
        };
    }

    static from(value: IProjectSparePart): ProjectSparePart {
        const sparePart = new ProjectSparePart(
            value.idProjectSparePart,
            value.idProject,
            value.idItem,
            value.itemMethodCode,
            value.itemDescription,
            value.quantity
        );
        sparePart.appliedPrice = value.appliedPrice;
        sparePart.totalPrice = value.totalPrice;
        return sparePart;
    }

}
